/**
 * Application Configuration
 *
 * Central configuration for app-wide settings that can be customized via environment variables.
 * These are typically used for branding and white-labeling client deployments.
 *
 * Environment variables:
 * - VITE_APP_NAME: Custom application name (default: "Vite Flare Starter")
 *
 * Example .dev.vars:
 * VITE_APP_NAME=My Client App
 */

// Helper to safely access import.meta.env (only available in Vite client builds)
const getEnv = (key: string): string | undefined => {
  if (typeof import.meta !== 'undefined' && import.meta.env) {
    return import.meta.env[key]
  }
  return undefined
}

export const appConfig = {
  /**
   * Application name displayed in sidebar, headers, and landing page
   */
  name: getEnv('VITE_APP_NAME') || 'JezPress Admin',
} as const

export type AppConfig = typeof appConfig
